import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FileText, ShoppingBag, FilePlus2, Banknote, PiggyBank, FileMinus2,
  FileBarChart2, Undo2, TrendingUp, CreditCard,
} from 'lucide-react';
import WorkflowItem from './WorkflowItem';
import WorkflowConnector from './WorkflowConnector';

/**
 * CUSTOMERS workflow panel: Estimates → Sales Orders → Create Invoices →
 * Receive Payments → Record Deposits, with credit/statement/refund
 * sub-actions below. "Create Invoices" is visually emphasized.
 */
export default function CustomerWorkflow() {
  const navigate = useNavigate();
  return (
    <section className="wf-panel">
      <header className="wf-header">
        <span className="wf-header-title">Customers</span>
      </header>
      <div className="wf-body">
        <div className="wf-flow">
          <WorkflowItem icon={FileText} label="Estimates" desc="Quotes & proposals" path="/estimates" />
          <WorkflowConnector />
          <WorkflowItem icon={ShoppingBag} label="Sales Orders" desc="Confirm customer orders" path="/sales-orders" />
          <WorkflowConnector />
          <WorkflowItem icon={FilePlus2} label="Create Invoices" desc="Bill your customers" path="/invoices/new" emphasized />
          <WorkflowConnector />
          <WorkflowItem icon={Banknote} label="Receive Payments" desc="Apply customer payments" path="/payments/new" color="green" />
          <WorkflowConnector />
          <WorkflowItem icon={PiggyBank} label="Record Deposits" desc="Deposit into bank" path="/banking" />
        </div>
        <div className="wf-sub">
          <button type="button" className="wf-sub-item" onClick={() => navigate('/payments')}>
            <FileMinus2 /> <strong>Customer Credits</strong>
          </button>
          <button type="button" className="wf-sub-item" onClick={() => navigate('/customers')}>
            <FileBarChart2 /> Statements
          </button>
          <button type="button" className="wf-sub-item" onClick={() => navigate('/payments')}>
            <Undo2 /> Refunds &amp; Credits
          </button>
          <span className="wf-sub-sep" />
          <button type="button" className="wf-sub-item" onClick={() => navigate('/reports')}>
            <TrendingUp /> Daily Sales
          </button>
          <button type="button" className="wf-sub-item" onClick={() => navigate('/payments')}>
            <CreditCard /> Credit Card Payments
          </button>
        </div>
      </div>
    </section>
  );
}
